<template>
  <div class="container">
    <h4 class="title is-4">Passkeys</h4>

    <div class="box" style="margin-bottom: 1.5rem;">
      <div class="field has-addons">
        <div class="control is-expanded">
          <input class="input" type="text" v-model="friendlyName" placeholder="Passkey name (optional)" />
        </div>
        <div class="control">
          <b-button type="is-success" @click="handleRegister" :loading="registering">
            Register New Passkey
          </b-button>
        </div>
      </div>
      <p v-if="registerError" class="has-text-danger" style="margin-top: 0.5rem;">{{ registerError }}</p>
    </div>

    <div v-if="loading" class="has-text-centered">
      <p>Loading passkeys...</p>
    </div>

    <div v-else-if="credentials.length === 0" class="has-text-grey">
      <p>No passkeys registered yet.</p>
    </div>

    <div v-else>
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Created</th>
            <th>Last Used</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cred in credentials" :key="cred.id">
            <td>{{ cred.friendlyName || 'Unnamed passkey' }}</td>
            <td>{{ cred.deviceType || '-' }}<span v-if="cred.backedUp"> (synced)</span></td>
            <td>{{ formatDate(cred.createdAt) }}</td>
            <td>{{ cred.lastUsedAt ? formatDate(cred.lastUsedAt) : 'Never' }}</td>
            <td>
              <b-button type="is-danger" size="is-small" outlined @click="handleDelete(cred)">
                Delete
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "screenfido",
  data() {
    return {
      friendlyName: '',
      registering: false,
      registerError: null
    };
  },
  computed: {
    ...mapGetters('fido', ['credentials', 'loading'])
  },
  methods: {
    ...mapActions('fido', ['fetchCredentials', 'registerPasskey', 'deleteCredential']),
    async handleRegister() {
      this.registering = true;
      this.registerError = null;
      const result = await this.registerPasskey(this.friendlyName || null);
      if (result.success) {
        this.friendlyName = '';
      } else {
        this.registerError = result.error;
      }
      this.registering = false;
    },
    async handleDelete(cred) {
      const name = cred.friendlyName || 'this passkey';
      if (confirm(`Delete ${name}?`)) {
        await this.deleteCredential(cred.id);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
    }
  },
  mounted() {
    this.fetchCredentials();
  }
};
</script>

<style scoped>
</style>
